import { formsConstants } from '@constants/forms';

const initialState = {
    data: {
        forms: [],
        totalCount: 0,
    },
    loading: true,
    loaded: false,
};

export function forms(state = initialState, action) {
    switch (action.type) {
        case formsConstants.FORMS_REQUEST:
            return { ...state, loading: true };
        case formsConstants.FORMS_SUCCESS:
            return { ...state, loading: false, loaded: true, data: action.forms };
        case formsConstants.FORMS_ERROR:
            return { ...state, loading: false, loaded: false };
        default:
            return state;
    }
}
